import { EColorVariablesV2 } from '@/types/theme-packs.types';
import { LinkProps } from './link.types';
import useGetColorForProjectThemeComponents from '@/utils/colors/use-get-color-for-project-theme-components';
import Link from '@ui/links/link';

interface ProjectColorLinkProps extends LinkProps {
  colorVariable?: EColorVariablesV2;
  contrastAgainstAppBackground?:
    | boolean
    | { colorToChange: EColorVariablesV2; colorToContrastAgainst: EColorVariablesV2 };
  'data-component'?: string;
}

const ProjectColorLink = ({
  children,
  colorVariable,
  contrastAgainstAppBackground,
  color: colorProp,
  backgroundColor: propsBackgroundColor,
  hoverBackgroundColor,
  'data-component': dataComponent,
  hoverOpacity = 0.8,
  ...rest
}: ProjectColorLinkProps) => {
  const { hex } = useGetColorForProjectThemeComponents({
    colorVariable,
    contrastAgainstAppBackground,
  });

  return (
    <Link
      backgroundColor={colorProp || hex || propsBackgroundColor}
      hoverBackgroundColor={hoverBackgroundColor || colorProp || hex}
      data-component={dataComponent || 'ProjectColorLink'}
      hoverOpacity={hoverOpacity}
      {...rest}
    >
      {children}
    </Link>
  );
};

export default ProjectColorLink;
